import App from "../../core/facade";

App.on("home_index:init", function() {
  App.log("Home page init");
  App.Widgets();
});
